import { useState, useEffect } from "react";
import API from "../lib/api";
import { Flame, Gift, Check } from "lucide-react";
import { toast } from "sonner";

export default function DailyReward() {
  const [data, setData] = useState(null);
  const [claiming, setClaiming] = useState(false);

  useEffect(() => {
    API.get("/daily-reward").then(r => setData(r.data)).catch(() => {});
  }, []);

  const claim = async () => {
    setClaiming(true);
    try {
      const { data: res } = await API.post("/daily-reward/claim");
      toast.success(res.message);
      setData(prev => ({ ...prev, streak: res.streak, can_claim: false, next_reward: prev.rewards[Math.min(res.streak, (prev.rewards?.length || 7) - 1)] }));
      // Play sound
      try { 
        // Use GameSounds if available
        if (window.GameSounds) {
          window.GameSounds.reward();
        }
      } catch {}
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setClaiming(false); }
  };

  if (!data) return null;

  return (
    <div className="bg-[#131722] rounded-xl border border-[#FFD600]/20 p-4" data-testid="daily-reward-widget">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Flame className="w-4 h-4 text-[#FFD600]" />
          <span className="text-sm font-bold text-[#F8FAFC]">Daily Streak</span>
          <span className="font-mono-game text-xs text-[#FFD600] bg-[#FFD600]/10 px-2 py-0.5 rounded-full">Day {data.streak}</span>
        </div>
        {data.can_claim && (
          <button onClick={claim} disabled={claiming} data-testid="claim-daily-btn"
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-bold uppercase tracking-widest bg-[#FFD600] text-[#0B0E14] rounded-lg hover:bg-[#FFD600]/90 disabled:opacity-50 shadow-[0_0_12px_rgba(255,214,0,0.3)] animate-pulse-glow">
            <Gift className="w-3.5 h-3.5" /> {claiming ? "..." : `Claim +${data.next_reward}`}
          </button>
        )}
      </div>
      <div className="flex gap-1.5">
        {(data.rewards || [10, 15, 25, 40, 60, 80, 150]).map((reward, i) => {
          const completed = i < data.streak;
          const isToday = i === data.streak && data.can_claim;
          return (
            <div key={`day-${i}`} className={`flex-1 rounded-lg p-2 text-center transition-all ${completed ? "bg-[#10B981]/20 border border-[#10B981]/30" : isToday ? "bg-[#FFD600]/10 border border-[#FFD600]/40 animate-pulse" : "bg-[#0B0E14] border border-[#2A3241]/30"}`}>
              <p className="text-[9px] text-[#64748B] mb-0.5">Day {i + 1}</p>
              {completed ? (
                <Check className="w-3.5 h-3.5 mx-auto text-[#10B981]" />
              ) : (
                <p className="font-mono-game text-xs font-bold" style={{ color: isToday ? "#FFD600" : "#64748B" }}>+{reward}</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
